<template>
    <div class="p-3">
        <div class="text-sm text-muted text-uppercase">
            {{ label }}
        </div>

        <div class="text-lg text-blue-600 font-weight-bold">
            {{ departureDate }} {{ departureTime }}
        </div>

        <div>
            {{ startPlace }}
            <span v-if="travel.selectedDepartureStop">
                {{ travel.selectedDepartureStop.description }}
            </span>
            -
            {{ endPlace }}
            <span v-if="travel.selectedArrivalStop">
                {{ travel.selectedArrivalStop.description }}
            </span>
        </div>

        <cart-additional-options />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import CartAdditionalOptions from './CartAdditionalOptions';

    export default {
        components: {
            CartAdditionalOptions,
        },
        props: {
            label: {
                type: String,
                required: true,
            },

            departureDate: {
                type: String,
                required: true,
            },

            departureTime: {
                type: String,
                required: true,
            },

            startPlace: {
                type: String,
                required: true,
            },

            endPlace: {
                type: String,
                required: true,
            },

            travel: {
                type: Object,
                required: true,
            },
        },
        computed: {
            ...mapGetters({
                defaultCurrencyCode: 'constants/getDefaultCurrencyCode',
            }),
        },
    };
</script>
